module.exports = __webpack_public_path__ + "static/img/2.b0e9df5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/eng/2.png
// module id = ICyO
// module chunks = 0